import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";

// External components
import ModalCreditCardNew from "../modalCreditCardNew/modalCreditCard";
import OverlayLoader from "../overlayLoader/overlayLoader";
@Component({ components: { ModalCreditCardNew, OverlayLoader } })
export default class PaymentMethodPicker extends Vue {
  @Prop({ default: null }) selectedPaymentMethod;
  @Prop({ default: null }) backgroundColor;

  @Action action_deleteCreditCard;

  @Getter getUser;
  @Getter getSubscription;

  isShowinCreditCardModal = false;
  isDeletingCreditCard = false;

  mounted() {
    const { payment_way, credit_card_id } = this.getSubscription;
    if (payment_way === "credit_card") {
      this.setPaymentMethod("credit_card", this.getCreditCardById(credit_card_id));
    } else {
      this.setPaymentMethod(payment_way);
    }
  }

  isPaymentMethodSelected(paymentMethodType, cardId) {
    if (this.selectedPaymentMethod && this.selectedPaymentMethod.type === paymentMethodType) {
      if (paymentMethodType === "credit_card") {
        return this.selectedPaymentMethod.card.id === cardId;
      }
      return true;
    }
    return false;
  }

  setPaymentMethod(paymentMethodType, card = null) {
    switch (paymentMethodType) {
      case "payment_link":
      case "cash":
      case "datafono":
        this.$emit("set-payment-method", {
          type: paymentMethodType,
          card: null,
        });
        break;
      case "credit_card":
        this.$emit("set-payment-method", {
          type: "credit_card",
          card,
        });
    }
  }

  getCreditCardById(creditCardId) {
    return this.getUser.credit_cards.find((creditCard) => creditCard.id === creditCardId);
  }

  async deleteCreditCard(creditCard: any) {
    let alert = await this.$swal({
      title: "Confirmar",
      text: "¿Deseas eliminar la tarjeta de credito ***" + creditCard.credit_card_number,
      showCancelButton: true,
      confirmButtonText: "Aceptar",
    });
    if (alert.value) {
      this.isDeletingCreditCard = true;
      await this.action_deleteCreditCard(creditCard.id);
      this.isDeletingCreditCard = false;
      this.setPaymentMethod("cash");
    }
  }
}
